export const parseISOLangToSimplified = (lang: string): string => (lang || '').replace(/-.*$/, '')
